import PropTypes from "prop-types";
import InputField from "components/InputField/InputField";
import Icon from "material-ui/Icon";
import FileField from "components/InputField/FileField";
import AddIcon from "material-ui-icons/Add";
import Button from "material-ui/Button";
import React from "react";
import Component from "react";
import ReactDOM from "react-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const getItems = (count) =>
  Array.from({ length: count }, (v, k) => k).map((k) => ({
    id: `item-${k}`,
    content: `item ${k}`,
  }));

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,
  background: isDragging ? "lightblue" : "white",
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "white" : "lightgrey",
  padding: grid,
  width: 350,
});

const AddSpeaker = ({
  onChange,
  speakers,
  onAddElement,
  onRemoveElement,
  onDragEnd,
}) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={getListStyle(snapshot.isDraggingOver)}
          >
            {speakers.map((speaker, index) => (
              <Draggable
                key={speaker.__id}
                draggableId={speaker.__id}
                index={index}
              >
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={getItemStyle(
                      snapshot.isDragging,
                      provided.draggableProps.style
                    )}
                  >
                    {
                      <div className="add_expert_row" key={speaker.__id}>
                        <h5>Expert {index + 1}</h5>
                        <Icon
                          onClick={() => onRemoveElement(speaker.__id)}
                          className="remove_expert"
                        >
                          close
                        </Icon>
                        <InputField
                          className="s12"
                          label="Expert name"
                          field_name="name"
                          onChange={(e) =>
                            onChange(speaker.__id, "name", e.target.value)
                          }
                          value={speaker.name}
                        />
                        <InputField
                          className="s12"
                          label="Expert type"
                          field_name="expert_type"
                          onChange={(e) =>
                            onChange(
                              speaker.__id,
                              "expert_type",
                              e.target.value
                            )
                          }
                          value={speaker.expert_type}
                        />
                        <InputField
                          className="s12"
                          label="Expert location"
                          field_name="location"
                          onChange={(e) =>
                            onChange(speaker.__id, "location", e.target.value)
                          }
                          value={speaker.location}
                        />
                        <InputField
                          className="s12"
                          label="Expert presentation title"
                          field_name="presentation_title"
                          onChange={(e) =>
                            onChange(
                              speaker.__id,
                              "presentation_title",
                              e.target.value
                            )
                          }
                          value={speaker.presentation_title}
                        />
                        <FileField
                          className=" s12"
                          field_name="expert_avatar_url"
                          onChange={(e) =>
                            onChange(
                              speaker.__id,
                              "expert_avatar_url",
                              e.target.value
                            )
                          }
                          label="Speaker Image"
                        />
                      </div>
                    }
                  </div>
                )}
              </Draggable>
            ))}
            <a
              className="add_option"
              onClick={onAddElement}
              href="javascript:void(0)"
            >
              Add another option
            </a>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
AddSpeaker.defaultProps = {};

AddSpeaker.propTypes = {
  onChange: PropTypes.func,
  onAddElement: PropTypes.func,
  onRemoveElement: PropTypes.func,
  speakers: PropTypes.array,
};

export default AddSpeaker;



// WEBPACK FOOTER //
// ./src/components/Admin/Speaker/AddSpeaker.jsx